<template>
	<div class="card">
		<div class="card-header" v-html="Translate('@_NOTIFICATIONS')"></div>
		<div class="card-body">
			<notifications-table></notifications-table>
		</div>
	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";
import NotificationsTable from "@/components/NotificationsTable";

export default {
	name: "Notifications",
	mixins: [Mixin],
	components: { NotificationsTable }
};
</script>

<style scoped></style>
